import { computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useHeightProps } from "./assets/index-BWUsUM8p.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { u as useVModel } from "./assets/index-BJV0_gaH.js";
import { m as model, e as emits } from "./assets/SingleInput-CTOYPcHF.js";
import XSkeletonLoader from "./XSkeletonLoader.js";
import XListItem from "./XListItem.js";
import XEllipsis from "./XEllipsis.js";
import { u as useProps, F as FirstColumn } from "./assets/FirstColumn-CbhWfnmf.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./assets/BaseLink-KuovKwoP.js";
import "./XCheckbox.js";
import "./BaseOption.js";
import "./XFormField.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/SingleMessage-Dv2wNb7f.js";
import "./XLink.js";
import "./XTooltip.js";
import "./assets/XDropdown-CrQavYks.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./MultipleInputs.js";
const XTableRow$1 = "_XTableRow_1uy3u_1";
const row = "_row_1uy3u_6";
const cell = "_cell_1uy3u_11";
const style0 = {
  XTableRow: XTableRow$1,
  row,
  cell
};
const { getHeightStyles } = useHeightProps();
const { setupTestId } = useDataTestIdProp();
const { setupVModel } = useVModel();
const { globalProps, rowProps, firstColumnProps } = useProps();
const __default__ = {
  name: "XTableRow",
  components: {
    XListItem,
    XSkeletonLoader,
    FirstColumn,
    XEllipsis
  },
  model
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    headers: {
      type: Array,
      default: () => []
    },
    gridTemplateColumns: {
      type: String,
      required: true
    },
    ...globalProps,
    ...rowProps,
    ...firstColumnProps
  },
  emits,
  setup(__props, { emit }) {
    const props = __props;
    const { data: isChecked } = setupVModel(props, emit);
    const { heightStyles } = getHeightStyles(props);
    const { formatTestId } = setupTestId(props);
    const { formatTestId: formatItemTestId } = setupTestId(props.item);
    function getValueByHeader(item, column) {
      return (item == null ? void 0 : item[column.value]) ?? "";
    }
    function getColumnStyle(column) {
      return {
        textAlign: (column == null ? void 0 : column.align) || "left"
      };
    }
    const rowCheckboxDataTestId = computed(() => formatItemTestId("row") || formatTestId("row"));
    return { __sfc: true, getHeightStyles, setupTestId, setupVModel, globalProps, rowProps, firstColumnProps, props, emit, isChecked, heightStyles, formatTestId, formatItemTestId, getValueByHeader, getColumnStyle, rowCheckboxDataTestId, XSkeletonLoader, XListItem, XEllipsis, FirstColumn };
  }
});
var _sfc_render = function render() {
  var _a, _b;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XListItem, _vm._b({ class: _vm.$style.XTableRow, attrs: { "role": "row", "tag": "li", "no-clickable": "", "disabled": (_a = _vm.item) == null ? void 0 : _a.disabled, "data-testid": (_b = _vm.item) == null ? void 0 : _b.dataTestid }, scopedSlots: _vm._u([{ key: "content", fn: function() {
    return [_c(_setup.FirstColumn, { attrs: { "item": _vm.item, "checkable": _vm.checkable, "loading": _vm.loading, "can-show-icon-space": _vm.canShowIconSpace, "data-testid": _setup.rowCheckboxDataTestId }, model: { value: _setup.isChecked, callback: function($$v) {
      _setup.isChecked = $$v;
    }, expression: "isChecked" } }), _c("div", { class: _vm.$style.row, style: {
      gridTemplateColumns: _vm.gridTemplateColumns
    }, attrs: { "data-testid": _setup.formatTestId("row") } }, _vm._l(_vm.headers, function(column) {
      return _c("div", { key: `cell-${column.value}`, class: _vm.$style.cell, style: _setup.getColumnStyle(column), attrs: { "role": "cell" } }, [_vm.loading ? _c(_setup.XSkeletonLoader, { attrs: { "type": "rect", "rounded": "", "height": "24px", "width": "100%", "data-testid": _setup.formatTestId("rowSkeletonLoader") } }) : _c(_setup.XEllipsis, { attrs: { "title": _setup.getValueByHeader(_vm.item, column), "visible-lines": _vm.maxRowLines, "data-testid": _setup.formatTestId("rowCellContent") } }, [_vm._t("column", function() {
        return [_vm._v(" " + _vm._s(_setup.getValueByHeader(_vm.item, column)) + " ")];
      }, { "column": column, "columnValue": _setup.getValueByHeader(_vm.item, column) })], 2)], 1);
    }), 0)];
  }, proxy: true }]) }, "XListItem", _setup.heightStyles, false));
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTableRow = __component__.exports;
export {
  XTableRow as default
};
